declare namespace $ {

	type $mol_view__sub_bog_ui_empty_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_empty_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_empty extends $mol_view {
		Icon( ): $mol_icon_magnify
		title( ): string
		Title( ): $mol_view
		message( ): string
		Message( ): $mol_view
		Action( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=empty.view.tree.d.ts.map